import Grid from "./grid";
import ProofWork from "./ProofWork/ProofWork";

export const Main = () => {
  const onSignIn = () => {
    let b: HTMLElement = document.getElementsByClassName(
      "wallet-adapter-button-trigger"
    )[0] as HTMLElement;
    if (b) {
      b.click();
    }
  };

  return (
    <>
      <div className="main__article">
        <h1>
          <div>
            <span>Shaping AI,</span>
          </div>
          <div>
            <span>Forging the Future</span>
          </div>
        </h1>
        <div className="title__row">
          <button onClick={onSignIn} id="sing__up">
            Connect wallet
          </button>
          <p>
            At AI Forge, we stand at the forefront of artificial intelligence
            development, harnessing the raw power of GPU technology to craft
            intelligent solutions that drive progress.
          </p>
        </div>
      </div>
      <div className="article__fixed">
        <div className="solutions__Tailored">
          <h2 data-aos="animation">
            AI Solutions Tailored for
            <br /> Excellence
          </h2>
          <div className="solutions__list">
            <div className="sl__item active" data-aos="animation">
              <div className="sli__body tierA ">
                <div className="sli__details">
                  <div className="sliname">Tier</div>
                  <div className="slinum">1</div>
                </div>
                <img src="images/tier01.webp" alt="" />
              </div>
            </div>
            <div className="sl__item" data-aos="animation">
              <div className="sli__body tierB">
                <div className="sli__details">
                  <div className="sliname">Tier</div>
                  <div className="slinum">2</div>
                </div>
                <img src="images/tier02.webp" alt="" />
              </div>
            </div>
            <div className="sl__item" data-aos="animation">
              <div className="sli__body tierC">
                <div className="sli__details">
                  <div className="sliname">Tier</div>
                  <div className="slinum">3</div>
                </div>
                <img src="images/tier03.webp" alt="" />
              </div>
            </div>
          </div>
          <div className="solutions__Tabs">
            <div className="st__item solTabA active">
              <div className="sti__top">
                <div className="stip__left">
                  <h2>
                    Single-GPU
                    <br /> Powerhouse
                  </h2>
                  <ul className="stip__list">
                    <li>
                      <i className="stiop01"></i>
                      <strong>1x</strong> NVIDIA GeForce RTX 4090
                    </li>
                    <li>
                      <i className="stiop02"></i>TRAIN 1 <strong>BOT</strong>
                    </li>
                    <li>
                      <i className="stiop03"></i>AROUND &nbsp<strong>82</strong>{" "}
                      TFLOPS
                    </li>
                  </ul>
                </div>

                <div className="stip__right">
                  <div className="srpr__title">Key features</div>
                  <ul>
                    <li>
                      This configuration is a dream setup for enthusiasts and
                      professionals alike, offering unparalleled single-GPU
                      performance. Ideal for high-end gaming, 3D rendering, and
                      AI development tasks that require significant
                      computational power.
                    </li>
                    <li>
                      Equipped with state-of-the-art cooling solutions to
                      maintain optimal performance under load.
                    </li>
                    <li>
                      Future-proofed with ample room for upgrades and
                      optimizations.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="sti__bottom">
                <div className="sti__title">Tire 01</div>
                <div className="sti__price">$200</div>
              </div>
            </div>

            <div className="st__item solTabB">
              <div className="sti__top">
                <div className="stip__left">
                  <h2>
                    Multi-GPU
                    <br /> Behemoth
                  </h2>
                  <ul className="stip__list">
                    <li>
                      <i className="stiop01"></i>
                      <strong>6x</strong> NVIDIA GeForce RTX 4090
                    </li>
                    <li>
                      <i className="stiop02"></i>TRAIN up to{" "}
                      <strong>2 BOT</strong>
                    </li>
                    <li>
                      <i className="stiop03"></i>AROUND <strong>492</strong>{" "}
                      TFLOPS
                    </li>
                  </ul>
                </div>

                <div className="stip__right">
                  <div className="srpr__title">Key features</div>
                  <ul>
                    <li>
                      A powerhouse setup designed for ultra-high performance in
                      professional rendering, complex simulations, and deep
                      learning tasks.
                    </li>
                    <li>
                      Features advanced cooling systems, including custom liquid
                      cooling loops, to manage heat from multiple GPUs.
                    </li>
                    <li>
                      Includes a high-end motherboard with ample PCIe slots to
                      support 6 GPUs, alongside a robust power supply to ensure
                      stable operations.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="sti__bottom">
                <div className="sti__title">Tire 02</div>
                <div className="sti__price">$500</div>
              </div>
            </div>
            <div className="st__item solTabC">
              <div className="sti__top">
                <div className="stip__left">
                  <h2>
                    Ultimate
                    <br /> Mega-PC
                  </h2>
                  <ul className="stip__list">
                    <li>
                      <i className="stiop01"></i>
                      <strong>12x</strong> NVIDIA GeForce RTX 4090
                    </li>
                    <li>
                      <i className="stiop02"></i>TRAIN up to
                      <strong>3 BOTs</strong>
                    </li>
                    <li>
                      <i className="stiop03"></i>AROUND <strong>984</strong>{" "}
                      TFLOPS
                    </li>
                  </ul>
                </div>
                <div className="stip__right">
                  <div className="srpr__title">Key features</div>
                  <ul>
                    <li>
                      The pinnacle of computational performance, this setup is
                      aimed at cutting-edge research, massive parallel
                      processing tasks, and high-performance computing
                      applications.
                    </li>
                    <li>
                      Integrates an enterprise-grade cooling system, possibly
                      involving external cooling units, to maintain optimal
                      temperatures across all GPUs.
                    </li>
                    <li>
                      Employs a custom-built chassis and motherboard designed
                      specifically to house and power 12 high-end GPUs, ensuring
                      maximum performance and reliability.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="sti__bottom">
                <div className="sti__title">Tire 03</div>
                <div className="sti__price">$1000</div>
              </div>
            </div>
          </div>
        </div>
        <ProofWork />
        <Grid></Grid>
      </div>
    </>
  );
};

export default Main;
